// extracted by mini-css-extract-plugin
module.exports = {"hiddenIFrame":"CookieChecker_hiddenIFrame__uTrLt"};